module.exports = "varying vec2 vUv;\nvarying float vNoise;\nvarying vec3 vNormal;\n\nfloat linearInterpolate(float a, float b, float t) {\n\treturn a * (1.0 - t) + b * t;\n}\n\nvoid main() {\n  float r = linearInterpolate(0.0, 0.9, vNoise); \n  float g = linearInterpolate(0.0, 0.9, vNoise); \n  float b = linearInterpolate(0.0, 0.9, vNoise); \n\n  gl_FragColor = vec4(r, g, b, 1.0);\n  //gl_FragColor = vec4(vNormal.rgb, 1.0);\n}"


//////////////////
// WEBPACK FOOTER
// ./src/shaders/my-frag.glsl
// module id = 127
// module chunks = 0